import BaseLayout from 'src/layouts/BaseLayout'
import { Flex, Box, Divider } from '@chakra-ui/react'
import SchoolListCell from 'src/components/SchoolListCell'
import ActivePagesCell from 'src/components/ActivePagesCell'

const ActivityStatPage = () => {
  return (
    <BaseLayout>
      <Flex>
        <Box minWidth={300} maxWidth={300}>
          <SchoolListCell selected={null} />
        </Box>
        <Divider orientation="vertical" marginX={0} />
        <ActivePagesCell />
      </Flex>
    </BaseLayout>
  )
}

export default ActivityStatPage
